/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { EvidencePart } from "@interfaces/Interfaces";
import { Text, View } from "@react-pdf/renderer";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";

type MenteeInfo = {
  name: string;
  esrNumber?: string;
  area?: string;
};

type Props = {
  definition: EvidencePart;
  onValueChanged: (value: any) => void;
  data?: MenteeInfo;
  isDisplay?: boolean;
  isPDF?: boolean;
  pdfStyles: any;
  initialValue: MenteeInfo;
};

const MenteeInfo: React.FC<Props> = (props) => {
  const value: MenteeInfo = props.initialValue;

  if (props.isPDF) {
    return (
      <View>
        <Text style={props.pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(props.definition)}</Text>
        <View style={{ marginTop: 8 }}>
          <Text style={props.pdfStyles.boldText}>{"Mentee Name:"}</Text>
          <Text style={props.pdfStyles.normalText}>{props.data?.name ?? "Not set"}</Text>
        </View>
        <View style={{ marginTop: 8 }}>
          <Text style={props.pdfStyles.boldText}>{"ESR Number:"}</Text>
          <Text style={props.pdfStyles.normalText}>{props.data?.esrNumber ?? "Not set"}</Text>
        </View>
        <View style={{ marginTop: 8 }}>
          <Text style={props.pdfStyles.boldText}>{"Area:"}</Text>
          <Text style={props.pdfStyles.normalText}>{props.data?.area ?? "Not set"}</Text>
        </View>
      </View>
    );
  }

  if (props.isDisplay) {
    return (
      <div className="mt-[20px]">
        <div className="text-acc-13px font-bold leading-default tracking-[-0.1px] text-grey-90 mb-3">
          {props.definition["Display Title"] ?? props.definition.Name}
        </div>
        <div className="text-acc-13px font-bold tracking-default text-grey-90 mb-1">{"Mentee Name:"}</div>
        <div className="text-acc-17px tracking-default text-grey-90">{props.data?.name ?? "Not set"}</div>
        <div className="text-acc-13px font-bold tracking-default text-grey-90 mb-1">{"ESR Number:"}</div>
        <div className="text-acc-17px tracking-default text-grey-90">{props.data?.esrNumber ?? "Not set"}</div>
        <div className="text-acc-13px font-bold tracking-default text-grey-90 mb-1">{"Area:"}</div>
        <div className="text-acc-17px tracking-default text-grey-90">{props.data?.area ?? "Not set"}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    );
  }

  return (
    <div className="mt-4">
      <div className="text-[15px] font-bold tracking-default text-grey-70 mb-1">{"Mentee Name:"}</div>
      <div className="text-[17px] tracking-default text-grey-90">{value?.name ?? "Not set"}</div>
      <div className="text-[15px] font-bold tracking-default text-grey-70 mt-2 mb-1">{"ESR Number:"}</div>
      <div className="text-[17px] tracking-default text-grey-90">{value?.esrNumber ?? "Not set"}</div>
      <div className="text-[15px] font-bold tracking-default text-grey-70 mt-2 mb-1">{"Area:"}</div>
      <div className="text-[17px] tracking-default text-grey-90">{value?.area ?? "Not set"}</div>
    </div>
  );
};

export default MenteeInfo;
